import { Outlet } from "react-router-dom";
import Header from "../components/header";
import Footer from "../components/footer";
import CookieConsentBanner from "../components/CookieConsentBanner";
import { Box } from "@mui/material";
import useVisitorTracking from "../CustomHooks/useVisitorTracking";
const BasicLayout = (props) => {
    useVisitorTracking();
    return (
        <Box sx={{ minHeight: '100vh', display: 'flex', flexDirection: 'column' }}>
            <Header />
            <Box component={'main'} sx={{ flex: 1,mx:'10px' }}>

                <Outlet />
            </Box>
            <Footer />
            <CookieConsentBanner />
        </Box>
    )
}

export default BasicLayout;